<template>
  <div id="app">
    <div class="pasek">
      <div >
        <nav>
          <div class='navigation'>
            <div class="logo">
              <img src=".\assets\logo_z_obwodka.png" width="80px" @click='main()'/>
            </div>
            <div class='title'><router-link to="/">TLK/TLI</router-link></div>
            <!-- <div ><router-link to="/">Główna</router-link></div> -->
            <!-- <div ><router-link to="/form">Formularz</router-link></div> -->
            <div v-if='isAuth' @click="$router.push('/form')" class='tab'>
              Dodaj lek
              <font-awesome-icon icon="plus-square" class='clickIconExit' />
            </div>
            <div v-if='isAuth' @click="out()" class='tab'>
              Wyloguj
              <font-awesome-icon icon="sign-out-alt"  class='clickIconExit'/>
            </div>
            <div v-if='!isAuth' class='tab' @click="$router.push('/login')">Zaloguj</div>
          </div>
          <hr>
        </nav>
      </div>
    </div>
    
    <div id="content1">
      <slot></slot>
    </div>

    <div class='footNoteIcon tooltip'>
            <font-awesome-icon icon="sign-in-alt"  class='clickIconExit' @click="signIn()" v-if='!isAuth'/>
            <span class='tooltiptext' v-if='!isAuth'>Zaloguj</span>
    </div>
  </div>
</template>

<script>
  import auth from "./auth";
  import { mapState, mapActions } from "vuex";
  import axios from 'axios';
  import router from './router'

  export default {
    name: "mainApp",
    data() {
      return {
        isAuth: false
      }
    },
    computed: {
      ...mapState({
        CurrentUser: state => state.CurrentUser.CurrentUser,
      }),
    },
    methods: {
      ...mapActions('CurrentUser', ['getCurrentUser']),
      ...mapActions("edytowane", ["deleteEdytowaneAll"]),
      out() {
        console.log('wyloguj')
        auth.logout();
        this.deleteEdytowaneAll()
        this.isAuth = false;
        this.$router.go()
      },
      signIn(){
        this.$router.push('/login')
      },
      main(){
        this.$router.push('/')
      }
    },
    created() {
      if (localStorage.getItem('token')){
        axios.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('token');
      }
      this.getCurrentUser()
      this.isAuth = auth.checkAuth()
    }

  };
</script>

<style>
  .navigation div{
    display: inline;
  }

  .navigation{
    text-align: right;
  }

  .navigation :first-child{
    text-align: left;
  }

  nav a:hover, .shadowFocus, .tab:hover{
    text-shadow: #555 2px 2px 2px!important;
  }

  nav {
    display: inline-block;
    width: 100%;
    margin-top: 10px 0px;
  }

  nav a {
    display: inline-block;
    padding: 8px 2%;
    font-weight: bold;
    font-size: 20px;
    text-decoration: none !important;
    line-height: 1;
    text-transform: uppercase;
    color:#004b8b;
  }

  .logo{
    padding: none !important;
    cursor:pointer;
    float: left; 
    margin-left:10px;
  }

  .title {
    padding: 8px 2%;
    font-size: 30px;
    text-decoration: none !important;
    text-align: left !important;
    margin-right: 100px;
  }

  hr{
    color:#004b8b;
    margin-left: 25px;
  }

  #content1 {
    margin: 10px 5%;
  }

  .tooltip {
    position: relative;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    min-width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;

    top: 100%;
    left: 50%;
    margin-left: -60px;
    font-size: 14px;
    margin-top:3px;
    font-weight: normal !important;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  .clickIconExit{
    cursor: pointer;
  }

  .footNoteIcon{
    float: right;
    margin-right: 10px;
    font-size: 20px;
  }

  .tab{
    margin-right:10px; 
    cursor: pointer;
  }

  .buttonRDTL{
    font-family: Georgia;
    padding: 4px;
    margin: 1px;
    /* background-color: #929090; */
    border-radius: 2px;
    border:solid 2px #004b8b;
    cursor: pointer;
  }
  .buttonRDTL:hover{
    background-color:#004b8b ;
    color:white;
  }

</style>